import { BREAKPOINTS } from '@app/constants/breakpoints';
import { AccountRequestStatus } from '@app/constants/requests';
import { AccountRequestHeaderActionButtons } from '@app/pages/AccountRequestDetailsPage/AccountRequestHeader/AccountRequestHeaderActionButtons';
import { AccountRequestHeaderActionButtonsMobile } from '@app/pages/AccountRequestDetailsPage/AccountRequestHeader/AccountRequestHeaderActionButtonsMobile';
import { AccountRequestStatusBar } from '@app/pages/AccountRequestDetailsPage/AccountRequestStatusBar';
import { useIsScreenSize } from '@app/utils/hooks';
import { useTranslation } from 'react-i18next';

interface Props {
  status?: AccountRequestStatus;
  createdAt: string;
  isLoading: boolean;
  isLoadingStatus: boolean;
  previousPath: Location | string;
  goToAccount: VoidFunction;
  onDecline: VoidFunction;
  onCreateAccount: VoidFunction;
  onArchive?: VoidFunction;
  onPending?: VoidFunction;
}

export const AccountRequestHeader = ({
  status,
  createdAt,
  isLoading,
  isLoadingStatus,
  previousPath,
  goToAccount,
  onCreateAccount,
  onDecline,
  onArchive,
  onPending,
}: Props) => {
  const { t } = useTranslation(['requests']);
  const isMobile = useIsScreenSize(BREAKPOINTS.SM);
  const isTablet = useIsScreenSize(BREAKPOINTS.MD);

  return (
    <div className="mb-8 flex flex-col gap-8">
      <div className="flex justify-between gap-3">
        <h2 data-sentry-mask className="heading-1">
          {t('requests:account_request')}
        </h2>
        {isMobile ?
          <AccountRequestHeaderActionButtonsMobile
            status={status}
            isLoading={isLoading}
            isLoadingStatus={isLoadingStatus}
            previousPath={previousPath}
            goToAccount={goToAccount}
            onCreateAccount={onCreateAccount}
            onDecline={onDecline}
            onArchive={onArchive}
            onPending={onPending}
          />
        : <AccountRequestHeaderActionButtons
            status={status}
            isLoading={isLoading}
            isLoadingStatus={isLoadingStatus}
            previousPath={previousPath}
            goToAccount={goToAccount}
            onCreateAccount={onCreateAccount}
            onDecline={onDecline}
            onArchive={onArchive}
            onPending={onPending}
            isTablet={isTablet}
        />
        }
      </div>
      <AccountRequestStatusBar status={status} createdAt={createdAt} />
    </div>
  );
};
